module.exports = [
  {
    type: "text",
    name: "firstName",
    label: "First Name *",
    value: "",
    required: true,
  },
  {
    type: "text",
    name: "lastName",
    label: "Last Name *",
    value: "",
    required: true,
  },
  {
    type: "email",
    name: "email",
    label: "Email *",
    value: "",
    required: true,
  },
  {
    type: "tel",
    name: "phone",
    label: "Phone *",
    value: "",
    required: true,
  },
  {
    type: "text",
    name: "postcode",
    label: "Postcode *",
    value: "",
    required: true,
  },
  {
    type: "select",
    name: "timeframeToPurchase",
    label: "Timeframe To Purchase *",
    value: "",
    required: true,
    options: [
      {
        label: "Select a timeframe",
        value: "",
        disabled: true,
        selected: true,
      },
      {
        label: "0 - 3 Months",
        value: "59B79C2D-87C1-4451-BE48-415DA6F069BF",
      },
      {
        label: "3 - 6 Months",
        value: "87703452-5D97-4D71-BDB4-D53B9383BA4C",
      },
      {
        label: "6 - 9 Months",
        value: "9543888B-4C74-42CD-B102-087B79136980",
      },
      {
        label: "9 - 12 Months",
        value: "5685F547-1C60-48F6-B775-B06F7F3ABF50",
      },
    ],
  },
  {
    type: "checkbox",
    name: "optIn",
    label: "I want to receive further information via email",
    value: "",
    required: false,
  },
  {
    type: "checkbox",
    name: "terms",
    label: `I have read and understood the <a class="underline" href="https://newenham.com.au/privacy-policy" target="_blank">privacy policy</a> *`,
    value: "",
    required: true,
  },
];
